import React, {memo} from 'react'
import {connect} from 'react-redux'
import FJTimelineTagBox from 'fj-components/FJTimelineTagBox';
import {FJTimeLineAction} from "../../../redux/action/FJRoot.action";
import styles from '../css/FJTimelineTagBoxContainer.module.less'

function FJTimelineTagBoxContainer(props) {

  const {changeMainerLayerVolume} = props;
  const {mainLayerVolume, isMainLayerEmpty} = props;
  const classes = {
    boxClassName:styles.left_tool,
    bgmClassName:styles.left_bgm,
    mainClassName:styles.tag_left,
    normalIconClassName: styles.tag_svg,
    volumeIconClassName: styles.line_left_voice
  };

  return (
    <FJTimelineTagBox changeMainerLayerVolume={changeMainerLayerVolume}
                      mainLayerVolume={mainLayerVolume}
                      mainLayerEmpty={isMainLayerEmpty}
                      classes={classes}
    />
  );
}

const mapStateToProps = function (state) {
  return {
    mainLayerVolume: state.timeline.mainLayerVolume,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    changeMainerLayerVolume: function (volume) {
      dispatch(FJTimeLineAction.changeMainerLayerVolumeAction(volume));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(memo(FJTimelineTagBoxContainer));
